
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center shadow-lg">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900 leading-tight">
                  Strategic
                </h1>
                <p className="text-xs text-blue-600 font-medium tracking-wide">
                  CONSULTING
                </p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">ホーム</a>
            <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">サービス</a>
            <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">会社概要</a>
            <a href="#case-studies" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">事例紹介</a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">お問い合わせ</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              無料相談予約
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">ホーム</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">サービス</a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">会社概要</a>
              <a href="#case-studies" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">事例紹介</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">お問い合わせ</a>
              <Button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                無料相談予約
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
